import React from "react";
import { Formik } from "formik";
import ReactHtmlParser from 'react-html-parser';

import { FieldNumber, FieldDropdown } from "../";

import step from "./styles/step.module.scss";
import styles from "./styles/styles.module.scss";
import { validationForm } from "./validation/validationForm";
import {systemSize} from "../../helpers";
import { useCalc } from "../../store/hooks/useCalc";

import text from "../../helpers/useText";


function validationData(max, size) {
  if ( systemSize(max, size) > 1000 ) {
    return text.stepOne.systemError;
  }
}

export const StepOne = () => {
  const { stepOneData, setStepOneData, clearStepTwoData, clearAll } = useCalc();

  const sizeArray = Array.from(Array(18), (d, i) => i+2);
  const maxArray = Array.from(Array(18), (d, i) => i+3);

  let systemError = '';

  const initialValues = stepOneData ? stepOneData : {
    size: '',
    max: '',
    bet: '',
  };

  const submitForm = (values, actions) => {
    systemError = validationData(values.max, values.size);
    actions.setSubmitting(false);

    if (!systemError) {
      clearStepTwoData();
      setStepOneData(values);
    }
  };

  const handlerClearAll = (e, resetForm) => {
    e.preventDefault();
    resetForm({});
    setStepOneData(false);
    clearAll();
  };

  return (
    <Formik
      enableReinitialize
      initialValues={ initialValues }
      validationSchema={ validationForm }
      onSubmit={ (values, actions) => submitForm(values, actions) }>
      {
        props => {
          const { values, errors, handleSubmit, handleChange, resetForm } = props;
          let errorForm = '';

          if ( errors.max === 'required' || errors.size === 'required' || errors.bet === 'required' ) {
            errorForm = text.stepOne.errorRequired
          } else if (errors.hasOwnProperty('max') && errors.hasOwnProperty('size') && errors.max === errors.size) {
            errorForm = errors.max
          } else if (!errors.hasOwnProperty('max') && !errors.hasOwnProperty('size') && errors.hasOwnProperty('bet')) {
            errorForm = errors.bet
          }

          return (
            <div className={styles.step_one}>
              <div className={step.step__header}>
                <div className={step.step__title}>{text.stepOne.title}</div>
                <div className={step.step__header_action}>
                  <div className={step.step__reset} onClick={(e) => handlerClearAll(e, resetForm)}><span className="ico-reset"/>{text.clearBtnText}</div>
                </div>
              </div>
              <div className={step.step__description}>
                { ReactHtmlParser(text.stepOne.description) }
              </div>
              <div className={styles.step_one__content}>
                <form className={styles.form} onSubmit={handleSubmit}>
                  <div className={styles.form__wrapper}>
                    <div className={styles.form__group}>
                      <div className={styles.form__field}>
                        <FieldDropdown
                          id="size"
                          type="text"
                          name="size"
                          autoComplete='size'
                          label={text.stepOne.field1}
                          placeholder="&#8211;"
                          value={values.size}
                          options={sizeArray}
                          onChange={handleChange}
                        />
                      </div>
                      <div className={styles.form__group_label}>{text.stepOne.groupLabel}</div>
                      <div className={styles.form__field}>
                        <FieldDropdown
                          id="max"
                          type="text"
                          name="max"
                          autoComplete='max'
                          label={text.stepOne.field2}
                          placeholder="&#8211;"
                          value={values.max}
                          options={maxArray}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className={styles.form__group}>
                      <div className={styles.form__field}>
                        <FieldNumber
                          id="bet"
                          type="text"
                          name="bet"
                          autoComplete='bet'
                          label={text.stepOne.field3}
                          placeholder={text.stepOne.field3Placeholder}
                          value={values.bet}
                          onChange={handleChange}
                        />
                      </div>
                      <div className={styles.form__field}>
                        <button className="c-btn" type="submit" data-id="to-login">
                          <div className="c-btn__text">{text.stepOne.btnText}</div>
                        </button>
                      </div>
                    </div>
                  </div>
                  {
                    <div className={styles.form__error}>
                      { (errorForm && errorForm) || (systemError && systemError) }
                    </div>
                  }
                </form>
              </div>
            </div>
          )
        }
      }
    </Formik>
  )

};
